module.exports = __webpack_public_path__ + "img/shibcoin-logo.aec75d73.svg";